var _g, _defs, _mask, _g2, _g3, _g4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg08BmwSpeedometer5YcMarkets(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 290 356",
    height: "356px",
    width: "290px",
    enableBackground: "new 0 0 290 356",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layout"
  }, /*#__PURE__*/React.createElement("line", {
    id: "baseline-1",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    x1: 60,
    y1: 333.5,
    x2: 222,
    y2: 333.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilterIi",
    filterUnits: "userSpaceOnUse",
    x: 66,
    y: 76,
    width: 150,
    height: 251
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "-1 0 0 0 1  0 -1 0 0 1  0 0 -1 0 1  0 0 0 1 0",
    colorInterpolationFilters: "sRGB",
    result: "source"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 66,
    y: 76,
    width: 150,
    height: 251,
    id: "_x35_y_2_"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#Adobe_OpacityMaskFilterIi)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 76,
    width: 9,
    height: 251
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102,
    y: 76,
    width: 9,
    height: 251
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137,
    y: 76,
    width: 9,
    height: 251
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 76,
    width: 9,
    height: 251
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207,
    y: 76,
    width: 9,
    height: 251
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_x35_y_1_",
    mask: "url(#_x35_y_2_)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_x34_y",
    d: "M66,316h9v11h-9V316z M102,327h9v-11h-9V327z M137,327h9v-11h-9V327z M172,327h9v-11h-9V327z M66,313h9v-80h-9 V313z M102,313h9v-80h-9V313z M137,313h9v-80h-9V313z M172,313h9v-80h-9V313z M66,230h9V125h-9V230z M102,230h9V125h-9V230z  M137,230h9V125h-9V230z M172,230h9V125h-9V230z M66,122h9V76h-9V122z M102,122h9V76h-9V122z M137,122h9V76h-9V122z M172,76v46h9 V76H172z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x35_y",
    fill: "#3C6BAD",
    d: "M207,316h9v11h-9V316z M207,313h9v-80h-9V313z M207,230h9V125h-9V230z M207,76v46h9V76H207z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "lines"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "sonstige-pin",
    fill: "none",
    stroke: "#3C6BAD",
    strokeMiterlimit: 10,
    points: "215.5,317 227,296 290,296  "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "asien-pin_1_",
    fill: "none",
    stroke: "#3C6BAD",
    strokeMiterlimit: 10,
    points: "215.5,233.5 227,206 290,206  "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "europa-pin",
    fill: "none",
    stroke: "#3C6BAD",
    strokeMiterlimit: 10,
    points: "215.5,125.5 227,106 290,106  "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "amerika-pin_1_",
    fill: "none",
    stroke: "#3C6BAD",
    strokeMiterlimit: 10,
    points: "215.5,77 227,36 290,36  "
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "text"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 203 351.7695)",
    fill: "#3C6BAD",
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "10px"
  }, "2020"), /*#__PURE__*/React.createElement("text", {
    id: "kpi-weitere",
    transform: "matrix(1 0 0 1 270.0269 291.5234)",
    fill: "#3C6BAD",
    fontFamily: "BMWGroupSerif, sans-serif",
    fontSize: "15px"
  }, "2,1"), /*#__PURE__*/React.createElement("text", {
    id: "head-weitere",
    transform: "matrix(1 0 0 1 24.0649 239.1387)",
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "7px"
  }, "Asien in %"), /*#__PURE__*/React.createElement("text", {
    id: "kpi-asien",
    transform: "matrix(1 0 0 1 262.124 201.5234)",
    fill: "#3C6BAD",
    fontFamily: "BMWGroupSerif, sans-serif",
    fontSize: "15px"
  }, "36,6"), /*#__PURE__*/React.createElement("text", {
    id: "head-asien_1_",
    transform: "matrix(1 0 0 1 18.1997 326.1387)",
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "7px"
  }, "Weitere in %"), /*#__PURE__*/React.createElement("text", {
    id: "kpi-europa",
    transform: "matrix(1 0 0 1 262.124 101.5234)",
    fill: "#3C6BAD",
    fontFamily: "BMWGroupSerif, sans-serif",
    fontSize: "15px"
  }, "42,7"), /*#__PURE__*/React.createElement("text", {
    id: "head-europa",
    transform: "matrix(1 0 0 1 19.8779 131.1387)",
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "7px"
  }, "Europa in %"), /*#__PURE__*/React.createElement("text", {
    id: "kpi-amerika",
    transform: "matrix(1 0 0 1 262.124 31.5234)",
    fill: "#3C6BAD",
    fontFamily: "BMWGroupSerif, sans-serif",
    fontSize: "15px"
  }, "18,6"), /*#__PURE__*/React.createElement("text", {
    id: "head-amerika",
    transform: "matrix(1 0 0 1 17.0923 81.1387)",
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "7px"
  }, "Amerika in %"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg08BmwSpeedometer5YcMarkets);
export default __webpack_public_path__ + "static/media/08_BMW_speedometer-5YC-markets.9a280b69.svg";
export { ForwardRef as ReactComponent };